import type { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { memo } from 'react';
import { useIntl } from 'react-intl';

import { engravingMessages } from '@/messages/engraving';

import type { StyleType } from '../types';

import * as S from './EngravingInputs.styles';

const MESSAGE_LINE_PATTERN = /\r?\n/g;

export interface EngravingMessageInputProps {
  hasError: boolean;
  message: string;
  setMessage: Dispatch<SetStateAction<string>>;
  style: StyleType;
}

const EngravingMessageInputComponent = ({
  hasError,
  message,
  setMessage,
  style,
}: EngravingMessageInputProps) => {
  const { formatMessage } = useIntl();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value.replaceAll(MESSAGE_LINE_PATTERN, ''));
  };

  const characterGuidanceMessage =
    style === 'Cursive'
      ? engravingMessages.messageCharacterGuidanceCursive
      : engravingMessages.messageCharacterGuidance;

  return (
    <S.MessageInputWrapper>
      <S.MessageInput
        $hasError={hasError}
        $style={style}
        aria-label={formatMessage(engravingMessages.optionMessage)}
        autoCapitalize='characters'
        autoComplete='off'
        hasError={hasError}
        inputMode='text'
        name='engravingMessage'
        onChange={handleChange}
        placeholder={formatMessage(characterGuidanceMessage)}
        value={message}
      />
    </S.MessageInputWrapper>
  );
};

export const EngravingMessageInput = memo(EngravingMessageInputComponent);
